import { EvidencePriorityIcon } from "./evidence-priority.types";

export const EVIDENCE_PRIORITIES = [
  {
    priority_id: 4,
    priority_name: "Urgent",
    color: "#f44336",
    icon: EvidencePriorityIcon.Flame,
  },
  {
    priority_id: 3,
    priority_name: "High",
    color: "#ff9800",
    icon: EvidencePriorityIcon.ChevronsRight,
  },
  {
    priority_id: 1,
    priority_name: "Low",
    color: "#4caf50",
    icon: EvidencePriorityIcon.ChevronRight,
  },
  {
    priority_id: 2,
    priority_name: "None",
    color: "#9e9e9e",
    icon: EvidencePriorityIcon.Minus,
  },
];
